import { useTranslation } from 'react-i18next'
import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'
import { messengerDoveLogo } from '@/assets/images'
import { Image } from '@/components/priority/Image/Image'

export const PdfProofWrapperFooter = ({
  contentDimensions,
}: {
  contentDimensions: { width: number; height: number }
}) => {
  const { t } = useTranslation()

  // Calculate scale factor based on content dimensions
  // Use a base size for standard letter size (612x792) and scale from there
  const baseWidth = 612
  const scaleFactor = Math.max(
    0.8,
    Math.min(2.0, contentDimensions.width / baseWidth),
  )

  const scaledDisclaimerSize = Math.min(Math.round(11 * scaleFactor), 20)
  const scaledCopyrightSize = Math.min(Math.round(10 * scaleFactor), 18)
  const scaledLogoHeight = `${Math.min(0.2 * scaleFactor, 0.3)}in`

  return (
    <Flex
      height="2.5in"
      padding="16px 32px"
      width="100%"
      gap="16px"
      column={true}
      justify="center"
      align="center"
    >
      <Flex
        height="1.8in"
        column={true}
        align="center"
        justify="center"
        overflow="hidden"
        maxWidth="85%"
        padding="8px 16px"
      >
        <Text
          size={`${scaledDisclaimerSize}px`}
          align="center"
          line="1.3"
          color="black"
          margin="0"
          weight="bold"
          maxWidth="100%"
        >
          <b>{t('pdf.colorDisclaimer')}</b> {t('pdf.colorDisclaimerText')}
        </Text>
      </Flex>

      <Flex height="0.4in" justify="center" align="center" gap="12px">
        <Text size={`${scaledCopyrightSize}px`} color="black" weight="bold">
          {t('pdf.allRightsReserved')} © {new Date().getFullYear()}
        </Text>
        <Image
          src={messengerDoveLogo}
          height={scaledLogoHeight}
          alt="Messenger Company Logo"
        />
      </Flex>
    </Flex>
  )
}
